import { useEffect, useState } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router';

import { Layout } from '@/components/Layout';
import { Button, Spinner } from '@/components/ui';
import { useApp } from '@/lib/hooks';
import { restore, startBackgroundSync, updateProfile } from '@/lib/store';
import { Categories } from '@/pages/Categories';
import { Dashboard } from '@/pages/Dashboard';
import { Expenses } from '@/pages/Expenses';
import { Insights } from '@/pages/Insights';
import { Settings } from '@/pages/Settings';
import { SignIn } from '@/pages/SignIn';

const router = createBrowserRouter(
  [
    {
      element: <Layout />,
      children: [
        { index: true, element: <Dashboard /> },
        { path: 'expenses', element: <Expenses /> },
        { path: 'insights', element: <Insights /> },
        { path: 'categories', element: <Categories /> },
        { path: 'settings', element: <Settings /> },
        { path: '*', element: <Dashboard /> },
      ],
    },
  ],
  { basename: '/app' },
);

/** Asks for a first name once, right after the first sign-in. */
function NameGate() {
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  return (
    <div className="auth-form" style={{ minHeight: '100%' }}>
      <form className="auth-card" onSubmit={async (e) => { e.preventDefault(); setBusy(true); await updateProfile({ firstName: name.trim() }).finally(() => setBusy(false)); }}>
        <h1 style={{ margin: 0, fontSize: 26 }}>What should we call you?</h1>
        <p className="muted" style={{ margin: 0 }}>Used for your greeting. You can change it in Settings.</p>
        <input className="input" value={name} maxLength={40} onChange={(e) => setName(e.target.value)} autoFocus aria-label="First name" />
        <Button size="lg" block disabled={!name.trim()} loading={busy} type="submit">Continue</Button>
        <Button variant="ghost" type="button" onClick={() => {
          sessionStorage.setItem('spendly.skipName', '1');
          location.reload();
        }}>Skip</Button>
      </form>
    </div>
  );
}

export function App() {
  const { auth, user } = useApp();
  useEffect(() => {
    void restore();
    return startBackgroundSync();
  }, []);

  if (auth === 'loading') {
    return <div style={{ display: 'grid', placeItems: 'center', height: '100%' }}><Spinner /></div>;
  }
  if (auth === 'signedOut') return <SignIn />;
  if (user && !user.firstName && !sessionStorage.getItem('spendly.skipName')) return <NameGate />;
  return <RouterProvider router={router} />;
}
